import { Component, effect, inject, signal } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { AuthSessionService } from './core/auth/auth-session.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('dm-admin-client');

  private readonly session = inject(AuthSessionService);
  private readonly router = inject(Router);

  constructor() {
    // Mantiene las pestañas en sync: AuthSessionService refleja un
    // login/logout de OTRA pestaña via el evento 'storage', y este effect
    // redirige esta pestaña para que coincida. No actua antes de la primera
    // navegacion real: esa la resuelven los guards (auth.guard/login.guard).
    effect(() => {
      const loggedIn = !!this.session.user();
      if (!this.router.navigated) return;

      const onLoginPage = this.router.url.startsWith('/login');
      if (!loggedIn && !onLoginPage) {
        this.router.navigate(['/login']);
      } else if (loggedIn && onLoginPage) {
        this.router.navigate(['/']);
      }
    });
  }
}
